import { IonChip, IonIcon, IonItem, IonLabel, IonRippleEffect, IonSpinner, IonText } from '@ionic/react';
import { buildOutline, pricetagOutline } from 'ionicons/icons';
import { ClockingDirection, ClockingType, IClockingHistory } from '../../models/dms/clocking.model';
import { IonCardWrapper } from './ClockingHisoryCard.styles';

interface IComponentProps {
  clockingHistory: IClockingHistory;
  handleClick: () => void;
  errorMessage?: string;
}

const ClockingHistoryCard: React.FC<IComponentProps> = ({ clockingHistory, handleClick, errorMessage }) => {
  return (
    <IonCardWrapper className="flexed-fill ion-activatable ripple-card" onClick={() => handleClick()}>
      {clockingHistory.type === ClockingType.Labour && <IonRippleEffect type="bounded" />}
      <IonItem lines="none">
        {clockingHistory.type === ClockingType.Attendance && (
          <>
            <IonIcon icon={buildOutline} size="small" color="medium" />
            <IonLabel className="ion-margin-start">Attendance</IonLabel>
          </>
        )}
        {clockingHistory.type === ClockingType.Labour && (
          <>
            <IonIcon icon={pricetagOutline} size="small" color="medium" />
            <IonLabel className="ion-margin-start">Labour</IonLabel>
          </>
        )}
        {clockingHistory.direction === ClockingDirection.On && <IonChip color="success">{clockingHistory.type === ClockingType.Attendance ? 'in' : 'on'}</IonChip>}
        {clockingHistory.direction === ClockingDirection.Off && <IonChip color="warning">{clockingHistory.type === ClockingType.Attendance ? 'out' : 'off'}</IonChip>}
        {clockingHistory.unSync && <IonSpinner name="lines-small" class="flexed flexed-right" />}
      </IonItem>
      {clockingHistory.type === ClockingType.Labour && (
        <div className="flexed">
          <IonItem lines="none">
            <IonLabel className="ion-text-nowrap" position="stacked" color="dark">
              Repair Order
            </IonLabel>
            <IonText className="ion-text-nowrap">
              {clockingHistory.branchCode} / {clockingHistory.repairOrderNumber}
            </IonText>
          </IonItem>
          <IonItem lines="none">
            <IonLabel className="ion-text-nowrap" position="stacked" color="dark">
              Job
            </IonLabel>
            <IonText className="ion-text-nowrap">
              {clockingHistory.jobType} / {clockingHistory.jobCode}
            </IonText>
          </IonItem>
        </div>
      )}
      <div className="ion-margin">
        <IonLabel color="danger" text-wrap>
          {errorMessage}
        </IonLabel>
      </div>
    </IonCardWrapper>
  );
};

export default ClockingHistoryCard;
